import React, { useState } from "react";
import { Download, CheckCircle } from "lucide-react";
import { subscribeNewsletter } from "@/lib/api";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";

const LEAD_MAGNET_URL = "/api/static/assets/c9e578ba_6rpbg1xu_PACT_From-Conflict-to-Connection-Leadership-Guide.pdf";

const LeadMagnet = ({ variant = "section" }) => {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const onSubmit = async (e) => {
    e.preventDefault();
    if (!email) return;
    setLoading(true);
    try {
      await subscribeNewsletter({ email });
      window.open(LEAD_MAGNET_URL, "_blank", "noopener");
      navigate("/thank-you");
    } catch (err) {
      toast.error("Something went wrong. Please try again.");
    } finally { setLoading(false); }
  };

  return (
    <section data-testid="lead-magnet-section" className="bg-[#8C4A57]">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 py-16 sm:py-20 grid grid-cols-1 md:grid-cols-12 gap-10 items-center">
        <div className="md:col-span-7 text-white">
          <div className="inline-flex items-center gap-2 text-[10px] tracking-[0.28em] uppercase bg-white/10 border border-white/20 rounded-sm px-3 py-1 mb-4">
            <Download className="w-3 h-3" /> Free Leadership Guide
          </div>
          <h2 className="text-3xl sm:text-4xl font-serif font-semibold leading-tight mb-4">
            The P.A.C.T. Framework
          </h2>
          <p className="text-white/85 leading-relaxed max-w-xl">
            A free preview of the P.A.C.T. Framework developed by Dr. Andrew Campbell. The
            P.A.C.T. framework — grounded in neuroscience, organizational psychology, emotional
            intelligence, and conflict resolution processes — provides organizational leaders with
            the tools to shift discourse from a defensive posture to a collaborative one.
          </p>
        </div>
        <div className="md:col-span-5">
          <form onSubmit={onSubmit} className="bg-white rounded-sm p-6" data-testid="lead-magnet-form">
              <label className="block text-xs uppercase tracking-wider text-[#6B5E62] mb-2">
                Your email
              </label>
              <input required type="email" value={email} onChange={(e) => setEmail(e.target.value)}
                data-testid="lead-magnet-email"
                placeholder="you@example.com"
                className="w-full px-4 py-3 bg-[#FAF4F5] border border-[#E8DCDD] rounded-sm focus:ring-2 focus:ring-[#D9C5C9] focus:outline-none text-sm mb-4" />
              <button type="submit" disabled={loading} data-testid="lead-magnet-submit"
                className="w-full bg-[#8C4A57] text-white hover:bg-[#703B45] py-3 rounded-sm text-sm font-semibold uppercase tracking-wide transition-colors duration-200 disabled:opacity-60">
                {loading ? "Sending..." : "Get the Free Guide"}
              </button>
              <p className="text-[10px] text-[#6B5E62] mt-3 text-center leading-relaxed">
                By subscribing you agree to receive occasional leadership insights. Unsubscribe anytime.
              </p>
            </form>
        </div>
      </div>
    </section>
  );
};

export default LeadMagnet;
